<div class="tabs {{type === 'underlined' ? 'row-gap-1p25' : 'row-gap-0p375'}}" [ngClass]="divTabsClass" @fadeInOut>
    <div *ngFor="let tab of tabNames; let i = index"
      [attr.data-qa]="tab.name"
      [ngClass]="tabStyleList" [class]="tab.currentClass" (click)="changeTab(i)">
      {{tab.name}}
    </div>
</div>
